import React from "react";
import "../Forms/Multistep/multistep.css";
import LegalDocument from './LegalDocument';
const TermsCondition = () => {
  return <LegalDocument documentType="terms_conditions" userType="host" />;
};

export default TermsCondition;
